.aj{aspect-ratio:1/1;}